<template>
    <div>
        <h1 class="display-heading">Employee Tier List</h1>

        <div class="card mb-3">
            <div class="card-header">Assign Tier</div>
            <div class="card-body">
                <div>
                    <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="checkConsentBeforeContinue('employee-tier-detail-add')">Create New Employee</button>

                    <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="checkConsentBeforeContinue('employee-tier-bulk-add')">
                        Bulk Upload  <i class="ml-2 fas fa-question-circle" data-toggle="tooltip" title="Add new employee, new dependent in bulk"></i>
                    </button>
                </div>

                <div v-if="employeeConsent.consentGiven" class="mt-3">
                    <hr>
                    <p class="mb-1"><b>Employee Consent of Data Sharing</b></p>
                    <p>You had previously confirmed the acceptance of the consent on {{ employeeConsent.acceptanceDate }}.</p>
                    <a :href="$store.state.operator.employer_consent_of_data_sharing_letter_url" class="btn btn-primary btn-primary-insv" target="_blank">View Document</a>
                </div>
            </div>
        </div>

        <div class="d-flex align-items-baseline">
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Full Name:</label>
                <input style="width: 150px" type="text" name="filterName" data-vv-as="filter full name" data-vv-validate-on="blur"
                    v-model="filterName"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterName')
                    }">
                <div v-show="validationErrors.has('filterName')" class="invalid-feedback">
                    {{ validationErrors.first('filterName') }}
                </div>
            </div>
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Identity Type:</label>
                <select name="filterIdentityType" data-vv-validate-on="blur" data-vv-as="identification type"
                    v-validate="identificationTypeValidation" v-model="filterIdentityType" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('filterIdentityType')
                }">
                    <option value="0">Please Select</option>
                    <option v-for="(identificationType, index) in identificationTypes" :key="index"
                        :value="identificationType.value">
                        {{identificationType.text}}
                    </option>
                </select>
                <div v-show="validationErrors.has('filterIdentityType')" class="invalid-feedback">
                    {{ validationErrors.first('filterIdentityType') }}
                </div>
            </div>
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Identity Number:</label>
                <input style="width: 150px" type="text" name="filterIdentityNumber" data-vv-as="filter NRIC" data-vv-validate-on="blur"
                    v-mask="filterIdentityType === 1 ? '######-##-####' : null" v-model="filterIdentityNumber"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterIdentityNumber')
                    }">
                <div v-show="validationErrors.has('filterIdentityNumber')" class="invalid-feedback">
                    {{ validationErrors.first('filterIdentityNumber') }}
                </div>
            </div>
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Tier:</label>
                <select style="width: 150px" name="filterTier" data-vv-as="filter tier" data-vv-validate-on="blur"
                    v-model="filterTier"
                    v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('employee-tier.filterTier')
                }">
                    <option :value="null">Choose...</option>
                    <option v-for="(tier, index) in tiers" :key="index" :value="tier.TierId">
                        {{tier.TierName}}
                    </option>
                </select>
                <div v-show="validationErrors.has('filterTier')" class="invalid-feedback">
                    {{ validationErrors.first('filterTier') }}
                </div>
            </div>
            <button @click="getEmployees" class="btn btn-primary">Search</button>
        </div>

        <div class="table-responsive">
            <div ref="tableSection">
                <table ref="listTable" class="table table-hover">
                    <col width="50">
                    <col>
                    <col width="100">
                    <col width="100">
                    <col width="200">
                    <col width="150">
                    <col width="150">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Employee Name</th>
                            <th scope="col">No. of <br> Spouse(s)</th>
                            <th scope="col">No. of <br> Dependent(s)</th>
                            <th scope="col">NRIC</th>
                            <th scope="col">Tier</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="employeeList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>
                        <tr v-for="(employee, index) in employeeList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) * pagination.pageSize ) + index + 1}}</th>
                            <td>{{employee.name}}</td>
                            <td>{{employee.spouseCount}}</td>
                            <td>{{employee.dependentCount}}</td>
                            <td>{{employee.nric}}</td>
                            <td>{{employee.tierName}}</td>
                            <td>
                                <router-link :to="{
                                    'name': 'employee-tier-detail',
                                    'params': {'id': employee.employeeTierId}
                                }">
                                View Employee
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>

        <popup-modal ref="popupModalConfirmation" :hasCloseButton="false" title="Employee Consent of Data Sharing">
            <template slot="content">
                <p>Please read, understand and confirm your acceptace of "Employee Consent of Data Sharing" before continue.</p>

                <a :href="$store.state.operator.employer_consent_of_data_sharing_letter_url" class="btn btn-primary btn-primary-insv" target="_blank">View Document</a>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv" @click="confirmConsentAcceptance">Accept</button>
                <button type="button" class="btn btn-secondary" @click="dismissConsentAcceptance">Cancel</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import $ from 'jquery';
import popupModal from '@/components/popup-modal';
import pagination from '@/components/pagination';
import identificationTypes from '@/config/identificationTypes';
import {
    convertToUserReadableDate
} from '@/utilities';
import {
    mask
} from 'vue-the-mask';
export default {
    'name': 'employeeList',
    'directives': {
        mask
    },
    'components': {
        pagination,
        popupModal
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        },
        identificationTypeValidation () {
            let minIdentificationType = this.identificationTypes[0].value;
            let maxIdentificationType = this.identificationTypes[this.identificationTypes.length - 1].value;

            return `required|between:${minIdentificationType},${maxIdentificationType}`;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getEmployees();
            });
        }
    },
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'tiers': [],
            'filterName': '',
            'filterIdentityType': 0,
            'filterIdentityNumber': '',
            'filterTier': '',
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'employeeList': [],
            identificationTypes,
            'employeeConsent': {
                'consentGiven': false,
                'acceptanceDate': null
            },
            'routeNext': ''
        };
    },
    mounted () {
        $('[data-toggle="tooltip"]').tooltip();
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // Get tiers for dropdown list
        this.axios.get('EmployeeTier/GetTierList')
            .then(({ data }) => {
                this.tiers = data.data.map((tiers) => ({
                    'TierId': tiers.ti,
                    'TierName': tiers.tn,
                    'EmployeeSpendingLimit': tiers.esl
                }));
            }).catch(() => {});

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getConsent();

        this.getEmployees();
    },
    'methods': {
        getConsent () {
            this.axios.get('company/GetConsent', {
                'params': {
                    'consentType': 1001
                }
            }).then(({ data }) => {
                if (data.data) {
                    let consent = data.data;
                    this.employeeConsent.consentGiven = consent.ia;
                    this.employeeConsent.acceptanceDate = consent.aa ? convertToUserReadableDate(consent.aa) : '-';
                }
            });
        },
        getEmployees () {
            this.axios.post('employeeTier/GetEmployeeList', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize,
                'fn': this.filterName,
                'it': this.filterIdentityType,
                'in': this.filterIdentityNumber,
                'ti': this.filterTier
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.employeeList = list.map((employee) => ({
                    'name': employee.fn ? employee.fn : '-',
                    'nric': employee.in ? employee.in : '-',
                    'tierName': employee.tn,
                    'employeeTierId': employee.eti,
                    'spouseCount': employee.sc,
                    'dependentCount': employee.dc
                }));
            });
        },
        checkConsentBeforeContinue (routeTo) {
            if (this.employeeConsent.consentGiven) {
                this.$router.push({
                    'name': routeTo
                });
            } else {
                this.routeNext = routeTo;
                this.$refs.popupModalConfirmation.show();
            }
        },
        confirmConsentAcceptance () {
            this.axios.post('company/UpdateConsent', {
                'ct': 1001,
                'ia': true
            }).then(({ data }) => {
                if (data.data) {
                    let consent = data.data;
                    this.employeeConsent.consentGiven = consent.ia;
                    this.employeeConsent.acceptanceDate = consent.aa ? convertToUserReadableDate(consent.aa) : '-';

                    this.$refs.popupModalConfirmation.hide().then(() => {
                        this.$router.push({
                            'name': this.routeNext
                        });
                    });
                }
            });
        },
        dismissConsentAcceptance () {
            this.$refs.popupModalConfirmation.hide();
        }
    }
};

</script>

<style>

</style>
